"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
var splide_1 = require("@splidejs/splide");
var Carousel = function () {
    var bar = document.querySelector(".progressBar__inner");
    var carousels = document.querySelectorAll(".splide");
    carousels.forEach(function (carousel) {
        var options = JSON.parse(carousel.getAttribute("options"));
        var showProgressBar = carousel.getAttribute("showProgressBar");
        var splide = new splide_1.default(carousel, options).mount();
        if (showProgressBar)
            splide.on("autoplay:playing", function (rate) {
                if (bar)
                    bar.style.width = "".concat(rate * 100, "%");
            });
    });
};
exports.Carousel = Carousel;
